/**
 * @file store主入口
 */

import Vuex from 'vuex'
import Vue from 'vue'
import mutations from './mutations'
import actions from './actions'
import libraryStore from 'library/store'
import role from './modules/role'
import user from './modules/user'
import menu from 'library/modules/menu/store'
import yearBudget from '@/modules/yearBudget/store.js'

Vue.use(Vuex)

let store = {
    strict: false,
    state: {
        userInfo: {},
        cachedViews: [],
        enumList: {},
        isVisible:false,
        isMessage: true, //消息中心
        isDetail: false, //详情显示
        whyMessage: 0,//防止消息中心闪现
        allNodes:[],//更新数据接口
        putNodes:[],
    },
    mutations,
    actions,
    modules: {
        role,
        user,
        menu,
        yearBudget,
    }
}

Object.assign(store.state, libraryStore.state)
Object.assign(store.actions, libraryStore.actions)
Object.assign(store.mutations, libraryStore.mutations)

export default new Vuex.Store(store)
